import * as React from 'react';

import * as styles from './SearchStringBlockLayout.css';

interface ISearchStringBlockLayoutProps {
  searchStringBlock: React.ReactNode;
  filtersBlock: React.ReactNode;
}

export const SearchStringBlockLayout: React.FC<React.PropsWithChildren<ISearchStringBlockLayoutProps>> = ({
  searchStringBlock,
  filtersBlock,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['search-string-block']}>{searchStringBlock}</div>
      {filtersBlock}
    </div>
  );
};
